import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import type { TripCard } from '../../redux/trip/trip.types';
import { ItemType } from '../../types/DragAndDrop';
import Card from './Card';

interface DraggableCardProps {
  card: TripCard;
  listId: string;
  tripId: string;
  canEdit?: boolean;
  listColor?: string;
}

function DraggableCard({ card, listId, tripId, canEdit, listColor }: DraggableCardProps) {
  const { setNodeRef, transform, isDragging, listeners, attributes } = useDraggable({
    id: card.id,
    data: { type: ItemType.CARD, card, listId },
    disabled: !canEdit,
  });

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Translate.toString(transform), opacity: isDragging ? 0 : undefined }}
      {...listeners}
      {...attributes}
    >
      <Card
        card={card}
        listId={listId}
        tripId={tripId}
        cardOrder={[]}
        canEdit={canEdit}
        isItinerarySidebarCard
        listColor={listColor}
      />
    </div>
  );
}

DraggableCard.displayName = 'DraggableCard';
export default DraggableCard;
